import { render, staticRenderFns } from "./OrderedHeader.vue?vue&type=template&id=bf0239ec&scoped=true"
import script from "./OrderedHeader.vue?vue&type=script&lang=js"
export * from "./OrderedHeader.vue?vue&type=script&lang=js"
import style0 from "./OrderedHeader.vue?vue&type=style&index=0&id=bf0239ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0239ec",
  null
  
)

export default component.exports